import { useEffect, useRef, useState } from "react";

/** A value that shows for `ms` once `flash` sets it, like a saved tick. */
export function useFlash<T>(ms: number) {
  const [shown, setShown] = useState<T | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);
  useEffect(() => () => clearTimeout(timer.current), []);
  const flash = (value: T) => {
    setShown(value);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setShown(null), ms);
  };
  return [shown, flash] as const;
}
